import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Box, Button, TextField, Typography } from "@mui/material";
import { ReactComponent as EmailSuccessIcon } from "../../assets/icons/email-success.svg";
import { ReactComponent as SuccessIcon } from "../../assets/Images/SuccessProjectIcon.svg";
import { ReactComponent as ArrowBackIcon } from "../../assets/icons/arrow-back.svg";
import { commonStyles } from "../../assets/MUIStyles/commonStyles";
import { resetPasswordAction } from "../NewDevelopment/Actions/CommonActions";
import BaseButton from "../NewDevelopment/Common/Buttons/BaseButton";
import { LoadingSlides } from "../NewDevelopment/CommonComponents/Common";
import CommonPopup from "../NewDevelopment/CommonComponents/PopUpCards/CommonPopup";
import NewAuthLayout from "./NewAuthLayout";
import ErrorPopUp from "../NewDevelopment/CommonComponents/PopUpCards/ErrorPopUp";

function ResetPassword() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [emailSent, setEmailSent] = useState(false);
  const [passwordPopup, setPasswordPopup] = useState(false);
  const [spin, setSpin] = useState(false);
  const [email, setEmail] = useState("");
  const [errorObj, setErrorObj] = useState({
    show: false,
    errMsg: "",
  });

  const resetPassword = async (e) => {
    e.preventDefault();
    setSpin(true);
    if (!email) {
      setErrorObj({
        show: true,
        errMsg: "Please enter a valid email",
      });

      setSpin(false);
      return;
    }
    let res: any = await dispatch(resetPasswordAction({ email: email.trim() }));
    if (res?.status !== 200) {
      setErrorObj({
        show: true,
        errMsg: res?.errMsg,
      });
      setEmailSent(false);
    } else {
      setEmailSent(true);
      setPasswordPopup(true);
    }

    setSpin(false);
  };
  const handleBack = () => {
    setEmailSent(false);
    setEmail("");
  };

  return (
    <NewAuthLayout>
      {emailSent ? (
        <Box className="flex-column-center">
          <EmailSuccessIcon />
          <Typography className="font-18-700-grey" gutterBottom>
            Verification Email Sent
          </Typography>
          <Typography className="font-13-400-grey" gutterBottom>
            We sent a password reset mail to{" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {email}
            </span>
          </Typography>
          <Typography className="font-13-400-grey mb-2">
            Please check your mail
          </Typography>
          <BaseButton
            title="Go Back"
            handleClick={handleBack}
            startIcon={<ArrowBackIcon />}
            styles={{ color: "#1A1D23", fontSize: 14, fontWeight: 400 }}
          />
          {passwordPopup && (
            <CommonPopup
              message={`Verification Email has been sent to your Email Id, Please verify to continue, if not received please check once on spam folder`}
              show={passwordPopup}
              toggle={() => setPasswordPopup((prev) => !prev)}
              Icon={SuccessIcon}
              heading=""
            />
          )}
        </Box>
      ) : (
        <>
          <Typography className="font-28-700-grey ">
            Forgot Password?
          </Typography>
          <Typography className="font-14-grey2" mb={2}>
            No worries we will send you a reset link
          </Typography>
          <Box mb={2}>
            <Typography className="font-14-grey mb-1">Email</Typography>
            <TextField
              name="email"
              value={email?.toLowerCase()}
              onChange={(e) => {
                setEmail(e.target.value.trim().toLowerCase());
              }}
              variant="outlined"
              fullWidth
              placeholder="Enter your registered email"
              sx={commonStyles.inputField}
            />
          </Box>

          <Button
            onClick={resetPassword}
            disabled={spin}
            variant="contained"
            sx={commonStyles.newAuthLoginButton}
            fullWidth
          >
            {spin ? <LoadingSlides bgColor="white" /> : "Reset Password"}
          </Button>
          <Box className="flex-row-center mt-2">
            <BaseButton
              title="Back to login"
              handleClick={() => history.push("/login")}
              startIcon={<ArrowBackIcon />}
              styles={{ color: "#1A1D23", fontSize: 14, fontWeight: 400 }}
            />
          </Box>
          <ErrorPopUp
            show={errorObj.show}
            toggle={() =>
              setErrorObj((prev) => ({
                ...prev,
                show: false,
                errMsg: "",
              }))
            }
            heading={"Error"}
            message={errorObj?.errMsg}
            spin={spin}
          />
        </>
      )}
    </NewAuthLayout>
  );
}

export default ResetPassword;
